<div fxLayout="row" fxLayoutAlign="center" class="side-main-menu">
    <!-- AI Gradient Line - animates on nav click (gradient theme only) -->
    @if (navLineAnimating && currentTheme === '2') {
        <div class="ai-init-line ai-init-glow"></div>
    }
    @if (!minimized) {
<!--        <mat-icon (click)="onClosed()" style="position: absolute; right: 45px; top: 10px; cursor: pointer" matTooltip="Close navigation">close</mat-icon>-->
        <mat-icon (click)="onMinimized()" style="position: absolute; right: 10px; top: 10px; cursor: pointer">keyboard_double_arrow_left</mat-icon>
    }
    @if (minimized) {
<!--        <mat-icon (click)="onClosed()" style="position: absolute; right: 10px; top: 10px; cursor: pointer" matTooltip="Close navigation">close</mat-icon>-->
        <mat-icon (click)="onMaximized()" style="position: relative; left: -5px; top: 10px; cursor: pointer">keyboard_double_arrow_right</mat-icon>
    }
    @if (showHelpEnabled === '1' && !minimized) {
        <div class="controlButtons" fxLayout="row" fxLayoutAlign="center center">
            <!--      <button mat-icon-button (click)="goToLink('chat')">-->
            <!--        <mat-icon matTooltip="{{'account.liveChat' | transloco}}">double_arrow</mat-icon>-->
            <!--      </button>-->
            @if (!liveChatStatus && (navChat$ | async) == '1') {
                <a (click)="goToLink('chat')" class="startLiveChat statusOff nav-icon">
                    <mat-icon matTooltip="{{'account.liveChatOffLine' | transloco}}">chat_bubble_outline</mat-icon>
                </a>
            }
            @if (liveChatStatus && (navChat$ | async) == '1') {
                <a (click)="goToLink('chat')" class="startLiveChat statusOn nav-icon">
                    <mat-icon matTooltip="{{'account.liveChatOnLine' | transloco}}">mark_chat_unread</mat-icon>
                </a>
            }
            <app-local-diag class="appLocalDiag nav-icon" [setLargeMode]="false" [iconButton]="false"></app-local-diag>
            @if (experienceLevel > experienceLevelType.BEGINNER) {
                @if (!networkCall) {
                    <a (click)="checkNetwork()" class="nav-icon">
                        <mat-icon matTooltip="{{'account.network' | transloco}}">cloud_queue</mat-icon>
                    </a>
                }
                @if (networkCall) {
                    <a (click)="checkNetwork()" class="nav-icon">
                        <mat-icon class="fade-in" matTooltip="{{'account.network' | transloco}}">cloud_upload</mat-icon>
                    </a>
                }
            }
            <a (click)="openThemeDialog()" class="nav-icon">
                <mat-icon matTooltip="{{'account.changeTheme' | transloco}}">format_color_fill</mat-icon>
            </a>
            @if (experienceLevel > experienceLevelType.BEGINNER) {
                <a (click)="showReleaseNotesDialog()" class="nav-icon">
                    <mat-icon matTooltip="release notes">tips_and_updates</mat-icon>
                </a>
                <a (click)="installPwa()" class="nav-icon">
                    <mat-icon matTooltip="{{'account.addToHome' | transloco}}">install_desktop</mat-icon>
                </a>
<!--                @if (!enterpriseMode) {-->
<!--                    <a (click)="openTwitter()" class="nav-icon">-->
<!--                        <mat-icon matTooltip="{{'account.news' | transloco}}">newspaper</mat-icon>-->
<!--                    </a>-->
<!--                }-->
            }
            <a (click)="logout()" class="nav-icon">
                <mat-icon matTooltip="{{'account.logout' | transloco}}">power_settings_new</mat-icon>
            </a>
        </div>
    }
</div>
<div [class.ai-nav-container]="currentTheme === '2'">
            @if (currentTheme === '2') {
                <div class="nav-ai-overlay">
                    <div class="strike-lines">
                        <span class="strike-line strike-1"></span>
                        <span class="strike-line strike-2"></span>
                        <span class="strike-line strike-3"></span>
                        <span class="strike-line strike-4"></span>
                        <span class="strike-line strike-5"></span>
                    </div>
                    <div class="nav-glow-orbs">
                        <span class="glow-orb orb-1"></span>
                        <span class="glow-orb orb-2"></span>
                        <span class="glow-orb orb-3"></span>
                    </div>
                </div>
            }
            <div>
                <mat-nav-list>
                    <!-- Main  -->
                    @if (dashboardMode || (navMain$ | async) == '1') {
                        <div>
                            @if (!dashboardMode && (signStudioResources$ | async) == '1') {
                                <a
                                        spinning
                                        mat-list-item
                                        routerLink="/home"
                                        routerLinkActive="active" (click)="onRouterClick()">
                                    <div class="nav-menu">
                                        <mat-icon class="spinning">explore</mat-icon>
                                        @if (!minimized) {
                                            <span class="nav-label">{{ 'navigation.home' | transloco }}</span>
                                        }
                                    </div>
                                </a>
                            }
                            @if (!dashboardMode && (signStudioEditor$ | async) == '1' && (studioType === EnumStudioType.SIGN_STUDIO || studioType === EnumStudioType.PRO)) {
                                <a
                                    routerLink="/editor/list"
                                    routerLinkActive="active"
                                    mat-list-item
                                    spinning
                                    (click)="onRouterClick()">
                                    <div class="nav-menu">
                                        <mat-icon class="spinning">control_camera</mat-icon>
                                        @if (!minimized) {
                                        <span class="nav-label">{{ 'navigation.scenes' | transloco }}</span>
                                        }
                                    </div>
                                </a>
<!--                                <a-->
<!--                                    routerLink="/editor/prompt"-->
<!--                                    routerLinkActive="active"-->
<!--                                    mat-list-item-->
<!--                                    spinning-->
<!--                                    (click)="onRouterPromptClick()">-->
<!--                                    <div class="nav-menu">-->
<!--                                        <mat-icon class="spinning">auto_awesome</mat-icon>-->
<!--                                        @if (!minimized) {-->
<!--                                            <span class="nav-label">AI prompt</span>-->
<!--                                        }-->
<!--                                    </div>-->
<!--                                </a>-->
                            }
                            @if (!dashboardMode && (signStudioResources$ | async) == '1') {
                                <a
                                    mat-list-item
                                    routerLink="/resources/list"
                                    routerLinkActive="active" (click)="onRouterClick()">
                                    <div class="nav-menu">
                                        <mat-icon>perm_media</mat-icon>
                                        @if (!minimized) {
                                        <span class="nav-label">{{ 'navigation.resources' | transloco }}</span>
                                        }
                                    </div>
                                </a>
                            }

                            @if (!dashboardMode && paintEnabled === '1' && (experienceLevel > experienceLevelType.BEGINNER || isPinned('paintEnabled')) && (signStudioPainter$ | async) == '1') {
                                <a
                                    mat-list-item
                                    routerLink="/paint/list" routerLinkActive="active"
                                    (click)="onRouterClick()">
                                    <div class="nav-menu">
                                        <mat-icon>color_lens</mat-icon>
                                        @if (!minimized) {
                                        <span class="nav-label">{{ 'navigation.painter' | transloco }}</span>
                                        }
                                    </div>
                                </a>
                            }
                            @if (!dashboardMode && catalogEnabled === '1' && (experienceLevel > experienceLevelType.BEGINNER || isPinned('catalogEnabled')) && (signStudioCatalog$ | async) == '1') {
                                <a mat-list-item
                                   routerLink="/catalog/list" routerLinkActive="active" (click)="onRouterClick()">
                                    <div class="nav-menu">
                                        <mat-icon>table_view</mat-icon>
                                        @if (!minimized) {
                                        <span class="nav-label">{{ 'navigation.catalog' | transloco }}</span>
                                        }
                                    </div>
                                </a>
                            }
                            @if (!dashboardMode && scheduledEnabled === '1' && (experienceLevel > experienceLevelType.BEGINNER || isPinned('scheduledEnabled')) && (signStudioScheduler$ | async) == '1') {
                                <a mat-list-item
                                   routerLink="/scheduler/editor" routerLinkActive="active" (click)="onRouterClick()">
                                    <div class="nav-menu">
                                        <mat-icon>calendar_month</mat-icon>
                                        @if (!minimized) {
                                            <span class="nav-label">{{ 'navigation.scheduler' | transloco }}</span>
                                        }
                                    </div>
                                </a>
                            }
                            @if (!dashboardMode && eventsEnabled === '1' && (experienceLevel == experienceLevelType.ADVANCED || isPinned('eventsEnabled')) && (signStudioEvents$ | async) == '1') {
                                <a mat-list-item
                                   routerLink="/events/list" routerLinkActive="active" (click)="onRouterClick()">
                                    <div class="nav-menu">
                                        <mat-icon>access_alarm</mat-icon>
                                        @if (!minimized) {
                                            <span class="nav-label">{{ 'navigation.events' | transloco }}</span>
                                        }
                                    </div>
                                </a>
                            }

<!-- Deprecated
                            @if (!dashboardMode && transitionsEnabled === '1' && experienceLevel == experienceLevelType.ADVANCED && (signStudioTransitions$ | async) == '1') {
                                <a mat-list-item
                                   routerLink="/transitions/list" routerLinkActive="active" (click)="onRouterClick()">
                                    <div class="nav-menu">
                                        <mat-icon>widgets</mat-icon>
                                        @if (!minimized) {
                                            <span class="nav-label">{{ 'navigation.transitions' | transloco }}</span>
                                        }
                                    </div>
                                </a>
                            }
-->

<!-- Deprecated
                            @if (!dashboardMode && musicEnabled === '1' && experienceLevel == experienceLevelType.ADVANCED && (signStudioMusic$ | async) == '1') {
                                <a mat-list-item
                                   routerLink="/music/list" routerLinkActive="active" (click)="onRouterClick()">
                                    <div class="nav-menu">
                                        <mat-icon>queue_music</mat-icon>
                                        @if (!minimized) {
                                            <span class="nav-label">{{ 'navigation.music' | transloco }}</span>
                                        }
                                    </div>
                                </a>
                            }
-->
                            @if (dashboardMode || (signStudioPlayers$ | async) == '1') {
                                <a mat-list-item
                                   routerLink="/stations"
                                   routerLinkActive="active" (click)="onRouterClick()">
                                    <div class="nav-menu">
                                        <mat-icon>tv</mat-icon>
                                        @if (!minimized) {
                                            <span class="nav-label">{{ 'navigation.players' | transloco }}</span>
                                        }
                                    </div>
                                </a>
                            }



                            @if (fasterqEnabled === '1' && (experienceLevel == experienceLevelType.ADVANCED || isPinned('fasterqEnabled')) && (signStudioFasterQ$ | async) == '1') {
                                <a mat-list-item
                                   routerLink="/fasterq/list" routerLinkActive="active" (click)="onRouterClick()">
                                    <div class="nav-menu">
                                        <mat-icon>merge_type</mat-icon>
                                        @if (!minimized) {
                                            <span class="nav-label">{{ 'navigation.fasterq' | transloco }}</span>
                                        }
                                    </div>
                                </a>
                            }


                            @if (dashboardMode || (dashboardEnabled === '1' && (experienceLevel > experienceLevelType.BEGINNER || isPinned('dashboardEnabled')) && (signStudioDashboard$ | async) == '1')) {
                                <a
                                    mat-list-item
                                    routerLink="/statistics"
                                    routerLinkActive="active" (click)="onRouterClick()">
                                    <div class="nav-menu">
                                        <mat-icon>speed</mat-icon>
                                        @if (!minimized) {
                                        <span class="nav-label">{{ 'navigation.dashboard' | transloco }}</span>
                                        }
                                    </div>
                                </a>
                            }

                        </div>
                    }


                    <!-- User Management -->
                    @if (dashboardMode || (navUser$ | async) == '1') {
                        <div>
                            <mat-divider></mat-divider>
                            @if (!minimized) {
                                <h3 class="montserratFamily" matSubheader>{{ 'general.userManagement' | transloco }}</h3>
                            }
                            @if (upgradable) {
                                <a mat-list-item
                                   spinning
                                   routerLink="/prices" routerLinkActive="active" (click)="onRouterClick()">
                                    <div class="nav-menu">
                                        <mat-icon color="warn" class="spinning">rocket_launch</mat-icon>
                                        @if (!minimized) {
                                            <span color="warn" class="nav-label">{{ 'navigation.prices' | transloco }}</span>
                                        }
                                    </div>
                                </a>
                            }
                            @if (dashboardMode || (signStudioDownloads$ | async) == '1') {
                                <a mat-list-item
                                   routerLink="/download" routerLinkActive="active" (click)="onRouterClick()">
                                    <div class="nav-menu">
                                        <mat-icon style="width: 26px">cloud_download</mat-icon>
                                        @if (!minimized) {
                                            <span class="nav-label">{{ 'navigation.download' | transloco }}</span>
                                        }
                                    </div>
                                </a>
                            }
                            @if (dashboardMode || (signStudioProducts$ | async) == '1') {
                                <a mat-list-item
                                   routerLink="/shopping/products" routerLinkActive="active" (click)="onRouterClick()">
                                    <div class="nav-menu">
                                        <mat-icon>sell</mat-icon>
                                        @if (!minimized) {
                                            <span class="nav-label">{{ 'navigation.products' | transloco }}</span>
                                        }
                                    </div>
                                </a>
                            }
                            @if (showAccount) {
                                <a mat-list-item
                                   spinning
                                   routerLink="/orders" routerLinkActive="active" (click)="onRouterClick()">
                                    <div class="nav-menu">
                                        <mat-icon class="spinning">face</mat-icon>
                                        @if (!minimized) {
                                            <span class="nav-label">{{ 'navigation.account' | transloco }}</span>
                                        }
                                    </div>
                                </a>
                            }
                            @if ((signStudioSettings$ | async) == '1') {
                                <a mat-list-item routerLink="/user"
                                   spinning routerLinkActive="active" (click)="onRouterClick()">
                                    <div class="nav-menu">
                                        <mat-icon class="spinning">settings</mat-icon>
                                        @if (!minimized) {
                                            <span class="nav-label">{{ 'navigation.settings' | transloco }}</span>
                                        }
                                    </div>
                                </a>
                            }
                            @if (enableDynawebs) {
                                <a mat-list-item
                                   routerLink="/dynawebs/list" routerLinkActive="active"
                                   (click)="onRouterClick()">
                                    <div class="nav-menu">
                                        <mat-icon>attach_money</mat-icon>
                                        @if (!minimized) {
                                            <span class="nav-label">dynawebs</span>
                                        }
                                    </div>
                                </a>
                            }
                            @if (enableDynawebs) {
                                <a
                                    mat-list-item
                                    routerLink="/rag"
                                    routerLinkActive="active" (click)="onRouterClick()">
                                    <div class="nav-menu">
                                        <mat-icon>psychology</mat-icon>
                                        @if (!minimized) {
                                        <span class="nav-label">AI DB</span>
                                        }
                                    </div>
                                </a>
                            }
                            @if (dashboardMode || (signStudioHelp$ | async) == '1') {
                                <a mat-list-item
                                   spinning
                                   routerLink="/help" routerLinkActive="active" (click)="onRouterClick()">
                                    <div class="nav-menu">
                                        <mat-icon class="spinning">help_outline</mat-icon>
                                        @if (!minimized) {
                                            <span class="nav-label">{{ 'navigation.help' | transloco }}</span>
                                        }
                                    </div>
                                </a>
                            }
                        </div>
                    }
                    <!-- Enterprise -->
                    @if (dashboardMode) {
                        <div>
                            <mat-divider></mat-divider>
                            @if (!minimized) {
                                <h3 class="montserratFamily" matSubheader>
                                    {{ 'general.enterprise' | transloco }}
                                    @if (upgradable) {
                                        <button (click)="upgrade()" routerLinkActive="active" style="position:relative; top: -2px"
                                                mat-button color="warn">[{{ 'navigation.upgrade' | transloco }}]
                                        </button>
                                    }
                                </h3>
                            }
                            <div [ngStyle]="{'opacity': dashboardMode ? 1 : 0.4}">
                                @if (dashboardMode) {
                                    <a mat-list-item
                                       routerLink="/enterprise/chat" routerLinkActive="active" (click)="onRouterClick()">
                                        <div class="nav-menu">
                                            <mat-icon>chat</mat-icon>
                                            @if (!minimized) {
                                                <span class="nav-label">{{ 'navigation.chat' | transloco }}</span>
                                            }
                                        </div>
                                    </a>
                                }
                                <a mat-list-item
                                   routerLink="/enterprise/users" routerLinkActive="active" (click)="onRouterClick()">
                                    <div class="nav-menu">
                                        <mat-icon>supervisor_account</mat-icon>
                                        @if (!minimized) {
                                            <span class="nav-label">{{ 'navigation.users' | transloco }}</span>
                                        }
                                    </div>
                                </a>
                                <a mat-list-item
                                   routerLink="/enterprise/privileges" routerLinkActive="active" (click)="onRouterClick()">
                                    <div class="nav-menu">
                                        <mat-icon>check</mat-icon>
                                        @if (!minimized) {
                                            <span class="nav-label">{{ 'navigation.privileges2' | transloco }}</span>
                                        }
                                    </div>
                                </a>
                                <a mat-list-item
                                   routerLink="/enterprise/apps" routerLinkActive="active" (click)="onRouterClick()">
                                    <div class="nav-menu">
                                        <mat-icon>featured_video</mat-icon>
                                        @if (!minimized) {
                                            <span class="nav-label">{{ 'navigation.apps' | transloco }}</span>
                                        }
                                    </div>
                                </a>
                                <a mat-list-item
                                   routerLink="/enterprise/whitelabel" routerLinkActive="active" (click)="onRouterClick()">
                                    <div class="nav-menu">
                                        <mat-icon>group_work</mat-icon>
                                        @if (!minimized) {
                                            <span class="nav-label">{{ 'navigation.whiteLabel' | transloco }}</span>
                                        }
                                    </div>
                                </a>
                                <a mat-list-item
                                   routerLink="/adnet/manager" routerLinkActive="active" (click)="onRouterClick()">
                                    <div class="nav-menu">
                                        <mat-icon>card_travel</mat-icon>
                                        @if (!minimized) {
                                            <span class="nav-label">{{ 'navigation.adnet' | transloco }}</span>
                                        }
                                    </div>
                                </a>
                            </div>
                        </div>
                    }
                </mat-nav-list>
            </div>
</div>
<ng-template let-modal #networkStatusModal>
    <div class="section-header" mat-dialog-title>
        <mat-icon class="section-icon">trending_up</mat-icon>
        <span class="section-title">{{ 'general.digitalSignageNetworkState' | transloco }}</span>
        <button mat-icon-button class="ss-dialog-close-btn" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div mat-dialog-content>
        <div fxLayout="row" fxLayoutAlign="center center">
            <app-server-avg style="width: 100%" class="card" [showServers]="false"></app-server-avg>
            <app-server-avg style="width: 100%" class="card" [showServers]="true"></app-server-avg>
        </div>
    </div>
</ng-template>

<ng-template let-modal #themeDialogModal>
    <div class="theme-dialog-header">
        <div class="theme-dialog-header-content">
            <mat-icon class="theme-dialog-icon">palette</mat-icon>
            <span class="theme-dialog-title">{{ 'account.changeTheme' | transloco }}</span>
        </div>
        <button style="position: relative; left: -20px; top: 10px" mat-icon-button class="ss-dialog-close-btn" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div mat-dialog-content class="theme-dialog-content">
        <div class="theme-dialog-subtitle">
            <mat-icon>auto_awesome</mat-icon>
            <span>{{ 'ai.chooseYourExperience' | transloco }}</span>
        </div>

        <div class="theme-cards-container">
            <!-- Dark Theme Card -->
            <div class="theme-card" (click)="selectThemeFromDialog('0')" [class.active]="currentTheme === '0'">
                <div class="theme-card-header">
                    <mat-icon class="theme-card-icon">dark_mode</mat-icon>
                    <span class="theme-card-name">{{'general.dark' | transloco}}</span>
                    @if (currentTheme === '0') {
                        <mat-icon class="theme-check-icon">check_circle</mat-icon>
                    }
                </div>
                <div class="theme-card-preview theme-preview-dark">
                    <div class="theme-preview-row">
                        <div class="theme-color-box" style="background: #1e1e1e;"></div>
                        <div class="theme-color-box" style="background: #2c2c2c;"></div>
                    </div>
                    <div class="theme-preview-row">
                        <div class="theme-color-box" style="background: #3e3e3e;"></div>
                        <div class="theme-color-box theme-accent" style="background: #03a9f4;"></div>
                    </div>
                </div>
                <div class="theme-card-description">
                    <small>{{ 'ai.classicDarkMode' | transloco }}</small>
                </div>
                <div class="theme-card-glow"></div>
            </div>

            <!-- Light Theme Card -->
            <div class="theme-card" (click)="selectThemeFromDialog('1')" [class.active]="currentTheme === '1'">
                <div class="theme-card-header">
                    <mat-icon class="theme-card-icon">light_mode</mat-icon>
                    <span class="theme-card-name">{{'general.light' | transloco}}</span>
                    @if (currentTheme === '1') {
                        <mat-icon class="theme-check-icon">check_circle</mat-icon>
                    }
                </div>
                <div class="theme-card-preview theme-preview-light">
                    <div class="theme-preview-row">
                        <div class="theme-color-box" style="background: #f1f1f1;"></div>
                        <div class="theme-color-box" style="background: #ffffff;"></div>
                    </div>
                    <div class="theme-preview-row">
                        <div class="theme-color-box" style="background: #e1e1e1;"></div>
                        <div class="theme-color-box theme-accent" style="background: #3f51b5;"></div>
                    </div>
                </div>
                <div class="theme-card-description">
                    <small>{{ 'ai.brightCleanMode' | transloco }}</small>
                </div>
                <div class="theme-card-glow"></div>
            </div>

            <!-- Gradient Theme Card -->
            <div class="theme-card theme-card-gradient" (click)="selectThemeFromDialog('2')" [class.active]="currentTheme === '2'">
                <div class="theme-card-header">
                    <mat-icon class="theme-card-icon">auto_awesome</mat-icon>
                    <span class="theme-card-name">deep night</span>
                    @if (currentTheme === '2') {
                        <mat-icon class="theme-check-icon">check_circle</mat-icon>
                    }
                </div>
                <div class="theme-card-preview theme-preview-gradient">
                    <div class="theme-preview-row">
                        <div class="theme-color-box" style="background: #030510;"></div>
                        <div class="theme-color-box" style="background: #040a1b;"></div>
                    </div>
                    <div class="theme-preview-row">
                        <div class="theme-color-box" style="background: linear-gradient(135deg, #040a1b, #e94560);"></div>
                        <div class="theme-color-box theme-accent" style="background: #e94560;"></div>
                    </div>
                </div>
                <div class="theme-card-description">
                    <small>{{ 'ai.modernGradientMode' | transloco }}</small>
                </div>
                <div class="theme-card-glow theme-card-glow-gradient"></div>
                <div class="theme-card-sparkles">
                    <span class="sparkle sparkle-1">✨</span>
                    <span class="sparkle sparkle-2">✨</span>
                    <span class="sparkle sparkle-3">✨</span>
                </div>
            </div>
        </div>

        <div class="theme-dialog-footer">
            <mat-icon>info</mat-icon>
            <span>{{ 'ai.themeChangesInstantly' | transloco }}</span>
        </div>
    </div>
</ng-template>
